import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  isLoading = new Subject<boolean>();
  constructor() { }
  /**
   * Show loader
   */
  show() {
    this.isLoading.next(true);
  }
  /**
   * Hide loader
   */
  hide() {
    this.isLoading.next(false);
  }
}
